function accordionOverride () {
  var accordionsController = document.querySelectorAll('.govuk-accordion__open-all')
  var accordions = document.querySelectorAll('.govuk-accordion__section')

  accordionsController.forEach(function (el) {
    el.setAttribute('aria-expanded', 'false')
    el.textContent = 'Open all'
  })

  accordions.forEach(function (accordion) {
    var toggle = accordion.querySelector('.govuk-accordion__section-button')
    toggle.setAttribute('aria-expanded', 'false')
    accordion.classList.remove('govuk-accordion__section--expanded')
  })
}

document.addEventListener('DOMContentLoaded', function () {
  if ('querySelector' in document) {
    accordionOverride()
  }
})
